var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menuItem",
      class: { notPointer: _vm.icon.includes("grey") },
    },
    [
      _vm.disabled
        ? _c("div", { attrs: { view: "#main-view" } }, [
            _c(
              "div",
              {
                staticClass: "roundHover whiteHover",
                class: _vm.isBoxRequest,
                style: _vm.backgroundStyleClick,
                attrs: { id: _vm.label.replace(/ /g, "") },
              },
              [
                _c(
                  "div",
                  { staticStyle: { filter: "invert(60%)" } },
                  [
                    _c("i", {
                      staticClass: "primary-icon",
                      style: _vm.backgroundStyleClick,
                      attrs: { icon: _vm.iconClass },
                    }),
                    _vm._v(" "),
                    _c(
                      "f7-label",
                      {
                        style:
                          "font-size: " +
                          _vm.labelStyle.size +
                          "px; color: grey",
                      },
                      [_vm._v(_vm._s(_vm.label))]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.showNumberBadge && _vm.notificationNumber !== "0"
              ? _c("span", { staticClass: "numberBadge" }, [
                  _vm._v(" " + _vm._s(this.notificationNumber) + " "),
                ])
              : _vm._e(),
          ])
        : _c(
            "f7-link",
            {
              attrs: {
                view: "#main-view",
                "close-panel": _vm.closePanel,
                "close-popup": _vm.closePopup,
              },
              on: {
                click: function ($event) {
                  return _vm.updatePage(_vm.clickAction)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "roundHover",
                  class: _vm.isBoxRequest,
                  style: _vm.backgroundStyleClick,
                  attrs: { id: _vm.label.replace(/ /g, "") },
                },
                [
                  _c(
                    "div",
                    { style: _vm.switchToWhite },
                    [
                      _c("i", {
                        staticClass: "primary-icon",
                        attrs: { icon: _vm.iconClass },
                      }),
                      _vm._v(" "),
                      _c(
                        "f7-label",
                        {
                          style:
                            "font-size: " +
                            _vm.labelStyle.size +
                            "px; color: " +
                            _vm.labelStyle.color,
                        },
                        [_vm._v(_vm._s(_vm.label))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.showNumberBadge && _vm.notificationNumber !== "0"
                ? _c("span", { staticClass: "numberBadge" }, [
                    _vm._v(" " + _vm._s(this.notificationNumber) + " "),
                  ])
                : _vm._e(),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }